import { Dialog, DialogContent, DialogTitle, Divider, IconButton, ThemeProvider, Typography, createTheme } from '@material-ui/core';
import { ptBR } from '@material-ui/core/locale';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';

import { useStyles } from './styles';
import { ChangeHistoryContent } from '../ChangeHistoryContent';

type ProductData = {
  id: number;
  title: string;
};

type ChangeHistoryModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  productData: ProductData;
};

const theme = createTheme(ptBR);

export const ChangeHistoryModal = ({ isOpen, handleClose, productData }: ChangeHistoryModalProps) => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={isOpen} onClose={handleClose} fullScreen>
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Typography variant='h6'>
            Histórico de alteração [{productData.id} - {productData.title}]
          </Typography>
          <IconButton aria-label='close' onClick={handleClose} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <ChangeHistoryContent productData={productData} />
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};
